module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/play_default_480x270-e39cad0757fa972cf83f93318af228f9.jpg";